import { ArticleIndex } from '@tjclifton/storyblok-react-utils';

export default ArticleIndex;
